import React, { useState, useEffect } from 'react';
import ProjectRequestCard from './ProjectRequestCard';
import ProjectDescription from './ProjectDescription';
import axios from '../axiosConfig';
import triangle from '../assets/images/triangle.png';
import '../assets/styles/ProjectRequest.css';

const ProjectsRequest = () => {
  const experiences = [
    { id: 1, name: 'Junior', created_at: '2024-01-01', updated_at: '2024-01-01' },
    { id: 2, name: 'Confirmed', created_at: '2024-01-01', updated_at: '2024-01-01' },
    { id: 3, name: 'Principal', created_at: '2024-01-01', updated_at: '2024-01-01' },
    { id: 4, name: 'Director', created_at: '2024-01-01', updated_at: '2024-01-01' }
  ];

  const names = [
    { id: 'sectors', name: 'Sector' },
    { id: 'domains', name: 'Domain' },
    { id: 'cities', name: 'City/remote' },
    { id: 'experiences', name: 'Experience' }
  ];

  const [filterOptions, setFilterOptions] = useState({
    // sectors: [{ id: 1, name: 'test1' }, { id: 2, name: 'test2' }, { id: 3, name: 'test3' }],
    // domains: [{ id: 1, name: 'test1' }, { id: 2, name: 'test2' }, { id: 3, name: 'test3' }],
    sectors: [],
    domains: [],
    cities: [],
    experiences: experiences
  });

  const [dropdowns, setDropdowns] = useState({
    sectors: false,
    domains: false,
    cities: false,
    experiences: false
  });

  const [searchTerms, setSearchTerms] = useState({
    sectors: '',
    domains: '',
    cities: '',
    experiences: ''
  });

  const [selectedFilters, setSelectedFilters] = useState({
    sectors: [],
    domains: [],
    cities: [],
    experiences: [],
    name: ''
  });

  const [projectRequests, setProjectRequests] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const [sectorsResponse, domainsResponse, citiesResponse] = await Promise.all([
          axios.get('/api/sectors'),
          axios.get('/api/practices'),
          axios.get('/api/cities')
        ]);

        setFilterOptions({
          sectors: sectorsResponse.data.data || [],
          domains: domainsResponse.data.data || [],
          cities: citiesResponse.data.data || [],
          experiences: filterOptions.experiences
        });
      } catch (error) {
        console.error('Error retrieving filter options:', error);
      }
    };

    fetchFilterOptions();
    handleSearch();
  }, []);

  const handleFilterChange = (e, category) => {
    const { value, checked } = e.target;
    setSelectedFilters(prev => ({
      ...prev,
      [category]: checked
        ? [...prev[category], value]
        : prev[category].filter(item => item !== value)
    }));
  };

  const handleNameChange = (e) => {
    setSelectedFilters(prev => ({
      ...prev,
      name: e.target.value
    }));
  };

  const handleSearchChange = (e, category) => {
    setSearchTerms(prev => ({ ...prev, [category]: e.target.value }));
  };

  const toggleDropdown = (category) => {
    setDropdowns(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const handleSearch = async () => {
    try {
      setProjectRequests([]);

      const response = await axios.get('/api/projects-requests', {
        params: selectedFilters
      });
      setProjectRequests(response.data.data);
    } catch (error) {
      console.error('Error when retrieving projects-requests:', error);
    }
  };

  const openProjectInfo = (project) => setSelectedProject(project);

  const closeProjectInfo = () => setSelectedProject(null);

  return (
    <div>
      {!selectedProject ? (
        <>
          <div className="filter-header">
            <input
              type="text"
              placeholder="Search by name..."
              value={selectedFilters.name}
              onChange={handleNameChange}
              className="search-bar"
            />
            <button className="search-button" onClick={handleSearch}>
              Search
            </button>
          </div>

          <div className="filter-row">
            {names.map(({ id, name }) => (
              <div key={id} className="filter-dropdown" style={{ width: '15%' }}>
                <button className="dropdown-button" onClick={() => toggleDropdown(id)}>
                  {name}
                  <img
                    src={triangle}
                    alt="triangle"
                    style={{
                      width: '20px',
                      height: '20px',
                      transform: dropdowns[id] ? 'rotate(0deg)' : 'rotate(180deg)',
                      marginLeft: '5px',
                      border: '1px solid #7f7f7f',
                      padding: '2px',
                      borderRadius: '5px',
                      backgroundColor: 'white'
                    }}
                  />
                </button>
                {dropdowns[id] && (
                  <div className="dropdown-content align-items-start" style={{ padding: '10px' }}>
                    <input
                      type="text"
                      placeholder="Type here"
                      value={searchTerms[id]}
                      style={{ width: '100%', marginBottom: '5px' }}
                      onChange={(e) => handleSearchChange(e, id)}
                    />
                    {filterOptions[id]
                      .filter(option => option.name.toLowerCase().includes(searchTerms[id].toLowerCase()))
                      .map(option => (
                        <label key={option.id}>
                          <input
                            type="checkbox"
                            value={option.id}
                            onChange={(e) => handleFilterChange(e, id)}
                          />
                          {' '+option.name}
                        </label>
                      ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="project-requests-list">
            {projectRequests.length > 0 ? (
              projectRequests.map(project => (
                <div key={project.id} onClick={() => openProjectInfo(project)}>
                  <ProjectRequestCard project={project} />
                </div>
              ))
            ) : (
              <p>No project proposals found</p>
            )}
          </div>
        </>
      ) : (
        <ProjectDescription project={selectedProject} onClose={closeProjectInfo} />
      )}
    </div>
  );
};

export default ProjectsRequest;
